/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

/**
 * Whether an attachment mime-type supports in-runner preview.
 * @param {String} [type]
 * @returns {Boolean}
 */
export function isPreviewSupportedFormat(type = '') {
    const normalized = String(type || '').toLowerCase();
    return (
        normalized === 'application/pdf'
        || normalized === 'text/html'
        || normalized === 'text/plain'
        || normalized.startsWith('image/')
    );
}
